import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import ReactDOM from 'react-dom/client'; // 1. Updated import path
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './styles/antd.css';

import { BrowserRouter } from "react-router-dom";

// 2. Create the root container using createRoot
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// 3. Render your app into the root
root.render(
  <ConfigProvider theme={{ hashed: false,
    token: {
    colorPrimary: '#ff7a38',
    fontFamily: 'AktivGrotesk',
  }, }}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>
);

reportWebVitals();